import "./instrument";
import { createRoot } from "react-dom/client";
import { ConfigProvider, App as AppContext } from "antd";
import { registerLicense } from "@syncfusion/ej2-base";
import "antd/dist/reset.css";

import "dayjs/locale/hr";
import locale from "antd/locale/hr_HR";

import "./index.css";
import "@/locales/i18n";
import App from "./App";
import appTheme from "./appTheme";

registerLicense(import.meta.env.VITE_SYNCFUSION_LICENSE_KEY);

createRoot(document.getElementById("root") as HTMLElement).render(
	<ConfigProvider locale={locale} theme={appTheme}>
		<AppContext>
			<App />
		</AppContext>
	</ConfigProvider>
);
